<!--
  //app/components/pages/region-matches-match-homeTeam-vs-awayTeam/MatchStatsLogosHeader.vue
  -->

<script setup lang="ts">
import { setAliasUrl, slugify } from "~/src/Shared/utils";
type Props = {
  homeTeamFirstColor: string | null;
  awayTeamFirstColor: string | null;
  homeTeamSecondColor: string | null;
  awayTeamSecondColor: string | null;
  homeTeamLogoUrl: string | undefined;
  awayTeamLogoUrl: string | undefined;
  homeTeamCompleteName: string | undefined;
  awayTeamCompleteName: string | undefined;
  awayTeamId: number | undefined;
  homeTeamId: number | undefined;
};

const props = defineProps<Props>();

const localePath = useLocalePath();

const defaultColor = "#888888";
</script>

<template>
  <div class="grid grid-cols-2 gap-x-1 place-items-center h-48 lg:rounded-t-lg overflow-hidden">
    <nuxt-link
      :to="
        localePath({
          name: 'teams-team-teamName',
          params: { team: homeTeamId, teamName: slugify(homeTeamCompleteName) },
        })
      "
      no-prefetch
      class="w-full h-full flex flex-col items-center justify-center"
      :style="`background-image: linear-gradient(90deg, ${props.homeTeamFirstColor || defaultColor}99 0%, ${props.homeTeamSecondColor || defaultColor} 100%)`"
    >
      <NuxtImg
        :src="setAliasUrl(props.homeTeamLogoUrl)"
        :alt="props.homeTeamCompleteName || ''"
        loading="lazy"
        class="w-24"
        width="96"
        height="96"
      />
      <p class="text-lg font-bold text-center">{{ props.homeTeamCompleteName }}</p>
    </nuxt-link>

    <nuxt-link
      :to="
        localePath({
          name: 'teams-team-teamName',
          params: { team: awayTeamId, teamName: slugify(awayTeamCompleteName) },
        })
      "
      no-prefetch
      class="w-full h-full flex flex-col items-center justify-center"
      :style="`background-image: linear-gradient(90deg, ${props.awayTeamFirstColor || defaultColor} 0%, ${props.awayTeamSecondColor || defaultColor}99 100%)`"
    >
      <NuxtImg
        :src="setAliasUrl(props.awayTeamLogoUrl)"
        :alt="props.awayTeamCompleteName || ''"
        loading="lazy"
        class="w-24"
        width="96"
        height="96"
      />
      <p class="text-lg font-bold text-center">
        {{ props.awayTeamCompleteName }}
      </p>
    </nuxt-link>
  </div>
</template>

<style scoped></style>
